"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _core = require("@material-ui/core");

var PasswordVisibilityToggle = function PasswordVisibilityToggle(_ref) {
  var visible = _ref.visible,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "Toggle Password Visibility",
    onClick: onClick,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: visible,
    alternate: /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_Visibility["default"], null)));
};

PasswordVisibilityToggle.propTypes = {
  visible: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = PasswordVisibilityToggle;
exports["default"] = _default;